import { render } from "./Manystore.vue?vue&type=template&id=31968b85"
import script from "./Manystore.vue?vue&type=script&lang=js"
export * from "./Manystore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__